
<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>

      <div>
        <div class="search-wrap">
          <el-form :inline="true">
            <el-form-item>
              <el-date-picker size="mini" v-model="year_value" type="year" format="yyyy" value-format="yyyy" placeholder="选择年份">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" @click="downloadTemplate">下载模板</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" @click="exportData">导出数据</el-button>
            </el-form-item>
            <el-form-item>
              <el-upload :action="upload_url" :on-success="uploadComplete" >
                <el-button type="primary" size="mini" @click="uploadTemplate">导入计划</el-button>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>

        <div class="table-wrap">
          <el-table v-loading="loading" :data="lists" height="660px">
            <el-table-column prop="id" label="项目ID" width="60"></el-table-column>
            <el-table-column prop="name" label="项目名称" width="200"></el-table-column>
            <el-table-column prop="leader" label="负责人" width="100"></el-table-column>
            <el-table-column v-for="month in [1,2,3,4,5,6,7,8,9,10,11,12]" :key="month" :label="month + '月'">
              <el-table-column label="计划(万元)">
                <template slot-scope="scope">
                  <span>{{scope.row[month].plan_amount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="实际(万元)">
                <template slot-scope="scope">
                  <span>{{scope.row[month].fact_amount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="回款率">
                <template slot-scope="scope">
                  <span>{{scope.row[month].rate}} % </span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="年度">
              <el-table-column label="计划(万元)">
                <template slot-scope="scope">
                  <span>{{scope.row.year.plan_amount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="实际(万元)">
                <template slot-scope="scope">
                  <span>{{scope.row.year.fact_amount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="回款率">
                <template slot-scope="scope">
                  <span>{{scope.row.year.rate}} % </span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AreaTree from "./components/AreaTree";
import CommonHelp from "./common/CommonHelp";
import Api from "./common/Api";
import {Message} from "element-ui";

export default ({
  name:"ContractPlan",
  components: {AreaTree},
  created(){
    this.year_value = CommonHelp.date("YYYY");
    this.upload_url = Api.getUploadUrl('/contract/FinancePlan/import_plan');
  },
  data(){
    return {
      upload_url : '',
      area_id : 0,
      year_value : '',
      lists : [],
      loading : false,
    };
  },
  computed: {
    changeParams(){
      return {
        area_id : this.area_id ,
        contract_area_ids :this.area_id,
        year : this.year_value,
      }
    },
  },
  watch : {
    changeParams(newVal){
      this.getList();
    },
  },
  methods : {
    nodeClick1(n){
      this.area_id = n.id;
    },
    downloadTemplate(){
      Api.downloadPlanTemplate(this.changeParams);
    },
    uploadTemplate(){

    },
    uploadComplete(res){
      if(res.code === 200){
        Message.success(res.msg)
      }else{
        Message.error(res.msg);
      }
    },
    exportData(){
      Api.exportPlan(this.changeParams)
    },
    getList(){
      let that = this;
      this.loading = true;
      Api.planList(this.changeParams , res => {
        that.lists = res;
        that.loading = false;
      })
    },
  }
})
</script>

<style scoped lang="scss">
@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ContractPlan.vue